module.exports = __webpack_public_path__ + "static/prepress-demo-cd3f691a81b0f06324d9a5659f07e756.mp4";